import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
import React from 'react';
import '../../App.css';
import Colors from '../Colors';

class ButtonLoader extends React.Component {
    render() {
        const TheIcon = this.props.icon;
        return (
            <button className={this.props.loading? "c-btn is-loading" : "c-btn"} style={this.props.isFinished ? {...this.props.style, backgroundColor: Colors.green }: {...this.props.style}} disabled={this.props.loading || this.props.disabled || this.props.isFinished} onClick={this.props.onClick}>
                {this.props.isFinished ? <CheckCircleOutlineIcon style={{marginRight: this.props.text? 10 : 0}}/> : TheIcon ? <TheIcon style={{marginRight: this.props.text? 10 : 0}}></TheIcon> : null}
                {this.props.text ? <span>{this.props.text}</span> : null}
            </button>
        );
    }
}

export default ButtonLoader